import { addParameterToContentfulUrl } from 'utils/addParameterToContentfulUrl'

export type PostImageType = {
  fields: {
    file: {
      url: string
      details: {
        image: {
          width: number
          height: number
        }
      }
    }
    title: string
  }
  sys?: {
    createdAt: string
    updatedAt: string
  }
}

type PostImageProps = {
  content: PostImageType
}

export const PostImage = ({ content }: PostImageProps) => {
  if (!content?.fields?.file) return null


  return <img src={`https:${addParameterToContentfulUrl(content.fields.file.url, 'fm', 'webp')}`} alt={content.fields.title} />
}
